<div class="edit-zona-grupo">
    <h2>EDITAR GRUPO</h2>
  
    <h3>Seleccionar Campo</h3>
    <div class="datosZona">
      <form [formGroup]="datosGrupo">
        <mat-form-field appearance="outline" class="dropdown" >
          <mat-select name="zona" placeholder="Filtrar por campo" class="selector__motivo" [(value)]="grupoSeleccionado"
            (selectionChange)="selectCampo($event.value)" formControlName="nombre">
            <mat-option *ngFor="let campo of campos" [value]="campo" >
              {{campo.nombre}}
            </mat-option>
  
          </mat-select>
        </mat-form-field>
        <div class="section-zg-edit">
          <h3>Editar nombre de campo</h3>
          <div class="displayFlexJustifyAlign">
            <input class="input-edit" type="text"  id="name" [(ngModel)]="inputNameCampo"
              value={{inputNameCampo}} formControlName="nameCampo"/>
              <button class="bbutton__primary btn-guardar-zg" (click)="updateNameCampo(inputNameCampo)" style="margin-top: 0.7rem;">Guardar</button>
          
          </div>
        </div>
     </form>
    </div>
    <h3>Añadir/Eliminar instalaciones al campo</h3>
    <mat-form-field appearance="outline">
  
      <mat-label>Instalaciones</mat-label>
      <mat-select multiple>
  
        <mat-checkbox (change)="selectAllInstalaciones($event.checked)"><strong>Seleccionar todas</strong></mat-checkbox>
        <mat-option *ngFor="let all of allInstalaciones" [value]="all.id" #matOption
          (click)="selectInstalacion(matOption)">{{all?.nombre}}</mat-option>
  
  
      </mat-select>
    </mat-form-field>
    <button class="button__secondary btn-editar-zg" (click)="handleClickInstal()">Añadir</button>
  
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" class="table-instalaciones"
      *ngIf="campoSeleccionado" >
      <div class="table-instalaciones">
        <ng-container matColumnDef="instalaciones">
          <th mat-header-cell *matHeaderCellDef> Instalaciones </th>
          <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
        </ng-container>
  
        <ng-container matColumnDef="eliminar">
          <th mat-header-cell *matHeaderCellDef style="width: '10%'"> Eliminar </th>
          <td mat-cell *matCellDef="let element" align="center" > <span><img role="button" (click)="deleteInstalacion(element)"
                src="../../../../../../assets/trash.png" />
            </span> </td>
        </ng-container>
      </div>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[8, 16, 32]" *ngIf="campoSeleccionado"></mat-paginator>
  
  </div>
